"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProbabilityParameterValue = exports.getEventProbabilityByMarketKey = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
var getEventProbabilityByMarketKey_1 = require("./getEventProbabilityByMarketKey");
Object.defineProperty(exports, "getEventProbabilityByMarketKey", { enumerable: true, get: function () { return getEventProbabilityByMarketKey_1.getEventProbabilityByMarketKey; } });
const getProbabilityParameterValue = (eventProbability) => eventProbability.parameters.find((parameter) => parameter.type === betweb_openapi_axios_1.ParameterType.Value);
exports.getProbabilityParameterValue = getProbabilityParameterValue;
//# sourceMappingURL=getProbabilityParameterValue.js.map